import React, { FC, useEffect, useState } from 'react'

import Lottie from 'lottie-react'
import { defineMessages, useIntl } from 'react-intl'

import animationData from './data.json'

export const SettingsDemo: FC = () => {
  const intl = useIntl()
  const [show, setShow] = useState(false)

  useEffect(() => {
    const textLayers = (animationData as any).layers.filter(
      (layer) => layer.ty === 5
    )

    textLayers.forEach((layer, index: number) => {
      /** Изменяем текст в слоях */
      layer.t.d.k[0].s.t = intl.formatMessage(messages[keys[index]])
    })

    setShow(true)
  }, [intl])

  if (show) {
    return <Lottie animationData={animationData} />
  }

  return null
}

export default SettingsDemo

const messages = defineMessages({
  hidePhoto: {
    id: 'settings.demo.1',
    defaultMessage: 'Не показывать фото в поиске',
  },
  filterMessages: {
    id: 'settings.filter.message',
    defaultMessage: 'Фильтр сообщений',
  },
  hideOnlineStatus: {
    id: 'settings.demo.3',
    defaultMessage: 'Не показывать онлайн-статус',
  },
  hideAge: {
    id: 'settings.hidden.age',
    defaultMessage: 'Скрывать возраст',
  },
  hideVisits: {
    id: 'settings.invisible.mode',
    defaultMessage: 'Скрывать визиты',
  },
  doNotDisturb: {
    id: 'settings.demo.6',
    defaultMessage: 'Не беспокоить',
  },
})

const keys = Object.keys(messages)
